module.exports = __webpack_public_path__ + "media/images/personnel/r-larocca-0b75bf2946f7e5453b09c84504d93068.jpg";